import { HateoasResource } from "@lagoshny/ngx-hateoas-client";
import { BaseEntity } from "@app/models/rest/base-entity";
import { TicketCompletionCode } from "@app/models/rest/ticket-completion-code";
import { AutoBookProfile } from "@app/models/rest/auto-book-profile";
import { MatchRule } from "@app/models/enums/match-rule";
import { MatchAction } from "@app/models/enums/match-action";

@HateoasResource("visitCompletionRules")
export class VisitCompletionRule extends BaseEntity {
  ordinal: number;
  ticketCompletionCode: TicketCompletionCode;
  matchRule: MatchRule;
  matchAction: MatchAction;
  autoBookProfile: AutoBookProfile;
}
